import Vue from 'vue'
import GetTextPlugin from 'vue-gettext'
import translations from './translations.json'

Vue.use(GetTextPlugin, {
    availableLanguages: {
        en: 'English',
        it: 'Italiano',
    },
    defaultLanguage: 'en',
    languageVmMixin: {
        computed: {
            currentKebabCase: function () {
                return this.current.toLowerCase().replace('_', '-')
            },
        },

        methods: {
            _: function (string, context) {
                const msgId = this.$gettext(string)
                if (context)
                    return this.$gettextInterpolate(msgId, context)
                return msgId
            }
        },
    },
    translations: translations,
    silent: true,
    autoAddKeyAttributes: true
})

// Apply debug overrides only if VUE_APP_DEBUG_I18N is enabled
if (process.env.VUE_APP_DEBUG_I18N === 'true') {
    // Override della direttiva v-translate per gestire msgid undefined
    const translateDirective = Vue.directive('translate')
    if (translateDirective) {
        const originalBind = translateDirective.bind
        const originalUpdate = translateDirective.update
        
        if (originalBind) {
            translateDirective.bind = function(el, binding, vnode) {
                try {
                    // Controlla se il testo esiste
                    const text = el.innerText || el.textContent || ''
                    if (!text || text.trim() === '') {
                        console.warn('[v-translate] Empty text in element:', el)
                        console.warn('[v-translate] Component:', vnode.context?.$options?.name || 'unknown')
                        return
                    }
                    // Chiama la funzione originale
                    return originalBind.call(this, el, binding, vnode)
                } catch (error) {
                    console.error('[v-translate] Error in bind:', error, 'Element:', el)
                    // Non crashare, lascia il testo originale
                }
            }
        }
        
        if (originalUpdate) {
            translateDirective.update = function(el, binding, vnode, oldVnode) {
                try {
                    const text = el.innerText || el.textContent || ''
                    if (!text || text.trim() === '') {
                        return
                    }
                    return originalUpdate.call(this, el, binding, vnode, oldVnode)
                } catch (error) {
                    console.error('[v-translate] Error in update:', error, 'Element:', el)
                }
            }
        }
    }

    // Override delle funzioni di traduzione per gestire msgid undefined
    Vue.mixin({
        created() {
            const vm = this
            
            // Salva le funzioni originali
            const original$gettext = vm.$gettext
            const original$pgettext = vm.$pgettext
            const original$ngettext = vm.$ngettext
            const original$npgettext = vm.$npgettext
            const original$gettextInterpolate = vm.$gettextInterpolate
            
            // Override $gettext
            if (original$gettext) {
                vm.$gettext = function(msgid) {
                    if (msgid === undefined || msgid === null) {
                        console.error('vue-gettext: msgid is undefined in $gettext')
                        console.error('Component:', vm.$options.name || vm.$options._componentTag || 'unknown')
                        console.error('Stack trace:', new Error().stack)
                        return ''
                    }
                    return original$gettext.call(this, msgid)
                }
            }
            
            // Override $pgettext
            if (original$pgettext) {
                vm.$pgettext = function(context, msgid) {
                    if (msgid === undefined || msgid === null) {
                        console.warn('vue-gettext: msgid is undefined in $pgettext')
                        return ''
                    }
                    return original$pgettext.call(this, context, msgid)
                }
            }
            
            // Override $ngettext
            if (original$ngettext) {
                vm.$ngettext = function(msgid, plural, n) {
                    if (msgid === undefined || msgid === null) {
                        console.warn('vue-gettext: msgid is undefined in $ngettext')
                        return ''
                    }
                    return original$ngettext.call(this, msgid, plural, n)
                }
            }
            
            // Override $npgettext
            if (original$npgettext) {
                vm.$npgettext = function(context, msgid, plural, n) {
                    if (msgid === undefined || msgid === null) {
                        console.warn('vue-gettext: msgid is undefined in $npgettext')
                        return ''
                    }
                    return original$npgettext.call(this, context, msgid, plural, n)
                }
            }
            
            // Override $gettextInterpolate
            if (original$gettextInterpolate) {
                vm.$gettextInterpolate = function(msgid, context, disableHtmlEscaping) {
                    if (msgid === undefined || msgid === null) {
                        console.error('vue-gettext: msgid is undefined in $gettextInterpolate')
                        console.error('msgid:', msgid)
                        console.error('Context:', context)
                        console.error('Context keys:', context ? Object.keys(context) : 'context is null/undefined')
                        console.error('Component:', vm.$options.name || vm.$options._componentTag || 'unknown')
                        console.error('Component data:', vm.$data)
                        console.error('Stack trace:', new Error().stack)
                        return ''
                    }
                    return original$gettextInterpolate.call(this, msgid, context, disableHtmlEscaping)
                }
            }
        }
    })
}